/******************************************************************************************
 *	Team Member Status
 *******************************************************************************************
 *
 * Mapper for team member's invitation status.
 *
 */
(function() {


  angular
    .module('rcServices.teamMemberStatus', [])
    .constant('TEAM_MEMBER_SERVER_STATUS', {
      PENDING: 'pending',
      ACTIVE: 'active'
    })
    .service(
      'TeamMemberStatus',
      /* @ngInject */
      function(_, TEAM_MEMBER_SERVER_STATUS) {
        this.isPending = function(status) {
          return _.toLower(status) === TEAM_MEMBER_SERVER_STATUS.PENDING;
        };

        this.isActive = function(status) {
          return _.toLower(status) === TEAM_MEMBER_SERVER_STATUS.ACTIVE;
        };
      }
    );
})();
